import React from "react";

const Icon = ({ ...props }) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="19.799"
        height="19.799"
        viewBox="0 0 19.799 19.799"
    >
        <g transform="translate(-21.601 -42.6)">
            <rect
                width="25"
                height="3"
                fill="#fff"
                data-name="Rectangle 255"
                rx="1.5"
                transform="rotate(-45 83.562 4.064)"
            ></rect>
            <rect
                width="25"
                height="3"
                fill="#11ff64"
                data-name="Rectangle 286"
                rx="1.5"
                transform="rotate(-135 32.562 23.065)"
            ></rect>
        </g>
    </svg>
);

export default Icon;